import { Action } from '@ngrx/store';

export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const LOG_OUT = 'LOG_OUT';

export class SignIn implements Action {
  readonly type = SIGN_IN;
  constructor(
    public payload: {
      account: string;
      password: string;
    }
  ) {}
}

export class SignInSuccess implements Action {
  readonly type = SIGN_IN_SUCCESS;
  constructor(
    public payload: {
      access_token: string;
      profile: any;
    }
  ) {}
}

export class SignInError implements Action {
  readonly type = SIGN_IN_ERROR;
}

export class LogOut implements Action {
  readonly type = LOG_OUT;
}

export type AuthActions = SignIn | SignInSuccess | SignInError | LogOut;
